module.exports = __webpack_public_path__ + "img/ic_upload_video@2x.2dc12454.png";